import { Skeleton } from "@/components/ui/skeleton"
 
export function GridSkeleton() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 content-center	mt-8 p-4">
      <Skeleton className="h-[340px] w-[260px]" />
      <Skeleton className="h-[340px] w-[260px]" />
      <Skeleton className="h-[340px] w-[260px]" />
      <Skeleton className="h-[340px] w-[260px]" />
    </div>
  )
}